import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

import { useOnlineStatus } from '@/hooks/useOnlineStatus';
import { cn } from '@/utils/cn';

export interface OfflineBannerProps {
  /** Already localized. */
  title: string;
  /** Already localized. */
  body: string;
  /** Already localized. Announced once when going offline. */
  offlineAnnouncement: string;
  /** Already localized. Announced once when coming back. */
  onlineAnnouncement: string;
  className?: string;
}

/**
 * Persistent and non-blocking. Never a modal: the player must still be able to read their payment
 * instructions offline, which is exactly when they need them.
 */
export function OfflineBanner({
  title,
  body,
  offlineAnnouncement,
  onlineAnnouncement,
  className,
}: OfflineBannerProps) {
  const online = useOnlineStatus({ offlineAnnouncement, onlineAnnouncement });

  if (online) return null;

  return (
    <div
      role="status"
      className={cn(
        'border-border bg-surface-muted text-text flex items-start gap-2.5 border-b px-4 py-2 text-sm sm:px-5',
        className,
      )}
    >
      <ExclamationTriangleIcon aria-hidden="true" className="text-warning mt-0.5 size-5 shrink-0" />
      <div className="min-w-0">
        <p className="font-medium">{title}</p>
        <p className="text-text-muted">{body}</p>
      </div>
    </div>
  );
}
